module.exports = __webpack_public_path__ + "static/media/dancer-girl.ba3b2ef2.png";